// extracted by css-extract-rspack-plugin
export default {"translation-detector":"textChangeTranslateDetector_translation-detector__jmgRs","translationDetector":"textChangeTranslateDetector_translation-detector__jmgRs"};